import React from 'react';
import ImageShow from '../../../../Uitiles/ImageShow';

const DEMO_ADS = [
    {
        image: "https://dummyimage.com/600x120/007bff/ffffff&text=Demo+Ad+1",
        link: "https://www.google.com",
        alt: "Demo Ad 1"
    },
    {
        image: "https://dummyimage.com/600x120/28a745/ffffff&text=Demo+Ad+2",
        link: "https://www.bing.com",
        alt: "Demo Ad 2"
    },
    {
        image: "https://dummyimage.com/600x120/ffc107/000000&text=Demo+Ad+3",
        link: "https://www.yahoo.com",
        alt: "Demo Ad 3"
    }
];

const getRandomAd = () => {
    const idx = Math.floor(Math.random() * DEMO_ADS.length);
    return DEMO_ADS[idx];
};

const Advertisement = ({ advertisement = [] }) => {
    const ad = advertisement;

    return (
        <div className="dc-searchresult-holder" style={{ marginTop: '20px' }}>
            <div className="dc-searchresult-grid dc-searchresult-list dc-searchvlistvtwo">
                <div className="dc-docpostholder dc-search-hospitals">
                    <div className="dc-docpostcontent">
                        <div className="dc-searchvtwo" style={{ width: '100%', maxWidth: '100%' }}>
                            <div className="dc-title d-flex justify-content-space-between">
                                <h3>{ad.banner_name || ''}</h3>
                                <a href={ad.redirect_link || ''} target="_blank" rel="noopener noreferrer">
                                    <button className="btn btn-primary">Click Here</button>
                                </a>
                            </div>
                            <div className="dc-google-ad" style={{ textAlign: 'center', borderRadius: '10px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
                                <a href={ad.redirect_link || ''} target="_blank" rel="noopener noreferrer">
                                    <ImageShow url={ad.imageUrl || ''} height={0} width={0} style={{ borderRadius: '5px' }} redirect={ad.redirect_link}/>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Advertisement;
